import { Button } from '@components/Button';
import { Icon } from '@components/Icon';
import { useSpeechToText } from '@hooks/useSpeechToText';
import { FC, useEffect } from 'react';
import { usePrevious } from 'react-use';

interface SpeechButtonProps {
  onTranscript: (transcript: string) => void;
  onListenStart?: () => void;
  className?: string;
}

export const SpeechButton: FC<SpeechButtonProps> = ({
  onTranscript,
  className,
  onListenStart,
}) => {
  const { transcript, isListening, startListening } = useSpeechToText();
  const prevListening = usePrevious(isListening);

  useEffect(() => {
    if (prevListening && !isListening && transcript) {
      onTranscript(transcript);
    }
  }, [isListening, onTranscript, prevListening, transcript]);

  useEffect(() => {
    if (!prevListening && isListening && onListenStart) {
      onListenStart();
    }
  }, [isListening, onListenStart, prevListening]);

  return (
    <Button
      className={className}
      disabled={isListening}
      title={isListening ? 'Listening...' : 'Start Listening'}
      css={{ minWidth: 40 }}
      onClick={(e) => {
        e.preventDefault();
        startListening();
      }}
    >
      {isListening && <Icon i="ellipsis" color="primary" size="md" />}
      {!isListening && <Icon i="microphone" color="primary" size="md" />}
    </Button>
  );
};
